export interface PoiConfig {
  /** When enabled, POI markers are only visible if their sight is not occluded */
  showVisibleOnly: boolean;
  /** How far (in world units) the occlusion probe may step toward the camera to avoid self-intersection */
  occlusionProbeMaxOffset: number;
  /** Minimum distance (in world units) to keep between the probe point and the POI center */
  occlusionProbeMinDistance: number;
}

export const defaultPoiConfig: PoiConfig = {
  showVisibleOnly: false,
  occlusionProbeMaxOffset: 0.2,
  occlusionProbeMinDistance: 0.02,
};
